module.exports = __webpack_public_path__ + "images/offers08fc72d35c8796ae37a1115e295b2a41.svg";